import { importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { Title, BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CoreModule } from "./app/core/core.module";
import { AppRouting } from "./app/routing";
import { ElementsModule } from "./app/elements/elements.module";
import { PipesModule } from "./app/pipes/pipes.module";
import { FeaturesModule } from "./app/features/features.module";
import { AppComponent } from "./app/app.component";

function launchApp(): void {
    bootstrapApplication(AppComponent, {
        providers: [
            importProvidersFrom(
                BrowserModule,
                BrowserAnimationsModule,
                RouterModule,
                FormsModule,
                ReactiveFormsModule,
                CoreModule.forRoot(),
                AppRouting,
                ElementsModule,
                PipesModule,
                FeaturesModule,
            ),
            Title,
            provideHttpClient(withInterceptorsFromDi()),
            provideZoneChangeDetection({ eventCoalescing: false }),
        ],
    }).catch((err) => console.log(err));
}

function bootstrap(): void {
    const href = window.location?.href;
    let delay = 120;

    if (href) {
        if (href.indexOf("oauth") !== -1 || href.indexOf("code=") !== -1) {
            delay = 1000;
        }
    }

    // Delay for OAuth processing
    setTimeout(launchApp, delay);
}

if (window["__bugsee__translationLoading"]) {
    window["__bugsee__translationLoading"].then(bootstrap).catch(bootstrap);
} else {
    bootstrap();
}
